module.exports = __webpack_public_path__ + "img/20200510_123157.c1b8dfed.jpg";